import React from 'react'
import ServiceRepo from '../repository/ServiceRepo';
import ServiceList from '../data-list/ServiceList';

const Services = () => {
  return (
    <div className="service-area horizontal">
      <div className="container">
        <div className="row">
          {ServiceRepo.serviceData.map((service, index) => (
            <ServiceList key={index} service={service} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services